// @flow
// Global stylesheet
import { injectGlobal } from 'styled-components'
import styledNormalize from 'styled-normalize'

// Styling
import { colors } from '../styles/styleGuide'
import { textStyles } from './textStyles'

injectGlobal`
  ${styledNormalize}

  html,
  body {
    width: 100%;
    height: 100%;
    ${textStyles.general};
    background-color: ${colors.white};
    color: ${colors.white};
  }

  #root {
    @import url('https://use.typekit.net/rez5snf.css');
    width: 100%;
    height: 100%;
  }

  a {
    color: ${colors.white};
  }
`



// WEBPACK FOOTER //
// ./src/styles/index.js